import { formatDate } from "../../../util/helpers";

export const SEARCH_DEBOUNCE_MS = 400;

export function getColumnDefs(t, { showCheckbox = true } = {}) {
  return [
    ...(showCheckbox
      ? [
          {
            headerCheckboxSelection: true,
            checkboxSelection: true,
            width: 60,
            maxWidth: 60,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            headerClass: "rmq-checkbox-header",
            cellClass: "rmq-checkbox-cell",
          },
        ]
      : []),
    {
      headerName: t("rmq_clientName"),
      field: "clientName",
      minWidth: 130,
      flex: 1.2,
      sortable: true,
      tooltipField: "clientName",
    },
    {
      headerName: t("rmq_engagementName"),
      field: "engagementName",
      minWidth: 140,
      flex: 1.3,
      sortable: true,
      tooltipField: "engagementName",
    },
    {
      headerName: t("rmq_serviceName"),
      field: "serviceName",
      minWidth: 110,
      flex: 1,
      sortable: true,
      tooltipField: "serviceName",
    },
    {
      headerName: t("rmq_engagementCode"),
      field: "engagementCode",
      minWidth: 130,
      flex: 1,
      sortable: true,
      tooltipField: "engagementCode",
      valueFormatter: (params) => params.value || "",
    },
    {
      headerName: t("rmq_creationDate"),
      field: "creationDate",
      minWidth: 130,
      flex: 1,
      sortable: true,
      valueFormatter: (params) => formatDate(params.value),
      tooltipValueGetter: (params) => formatDate(params.value),
    },
    {
      headerName: t("rmq_office"),
      field: "office",
      minWidth: 100,
      flex: 0.8,
      sortable: true,
      tooltipField: "office",
    },
    {
      headerName: t("rmq_country"),
      field: "country",
      minWidth: 100,
      flex: 0.8,
      sortable: true,
      tooltipField: "country",
    },
    {
      headerName: t("rmq_region"),
      field: "region",
      minWidth: 90,
      flex: 0.7,
      sortable: true,
      tooltipField: "region",
    },
  ];
}
